import { Injectable } from '@angular/core';
import { BehaviorSubject, ReplaySubject, firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CloudflareChallengeService {
  private tokenSubject: ReplaySubject<string> | null = null;
  private activeSubject = new BehaviorSubject<boolean>(false);
  public isChallengeActive$ = this.activeSubject.asObservable();

  startTurnstileChallenge(): Promise<string> {
    this.activeSubject.next(true);
    this.tokenSubject = new ReplaySubject<string>(1);
    return firstValueFrom(this.tokenSubject);
  }

  resolveWithToken(token: string): void {
    if (token) {
      this.tokenSubject?.next(token);
      this.tokenSubject?.complete();
      this.activeSubject.next(false);
    }
  }
}
